var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "600px",
    height: "400px",
    viewBox: "0 0 600 400",
    enableBackground: "new 0 0 600 400",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#69459B",
    d: "M247.837,135.582h24.371V111.21h-24.371V135.582z M395.041,40.532H229.803 c-4.576,0-8.287,3.711-8.287,8.287v141.688c8.217,0.852,14.624,7.794,14.624,16.238c0,3.877-1.358,7.435-3.615,10.235 c5.366,1.008,10.177,3.568,13.976,7.182l41.667-43.095c0.871,1.354,1.931,2.767,3.282,4.223c1.154,1.243,2.254,2.306,3.298,3.214 l-45.945,38.13c3.342,4.055,5.567,9.064,6.173,14.569c2.995-3.63,7.528-5.943,12.602-5.943c8.854,0,16.045,7.049,16.304,15.84 h60.708l56.299-56.482V46.381C400.89,43.15,398.271,40.532,395.041,40.532z M244.912,60.516h30.221v30.221h-30.221V60.516z  M244.912,138.506v-30.221h30.221v30.221H244.912z M254.052,208.45l30.702-38.59c-0.083,1.521,0.057,4.193,1.443,7.513 L254.052,208.45z M264.06,219.118l34.097-28.043c2.953,1.896,5.237,2.476,6.653,2.605L264.06,219.118z M247.837,87.813h24.371 V63.441h-24.371V87.813z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#513078",
    d: "M352.999,194.802h47.157l-55.565,55.568v-47.157C344.591,198.566,348.355,194.802,352.999,194.802z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69459B",
    d: "M221.667,225.369c-8.775,0-16.525,4.296-21.328,10.878c3.417-1.612,7.222-2.54,11.253-2.54 c14.581,0,26.4,11.819,26.4,26.4c0,5.809-1.896,11.162-5.075,15.522c8.945-4.229,15.15-13.309,15.15-23.86 C248.068,237.188,236.249,225.369,221.667,225.369z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M331.434,184.738c0,0,31.056-13.607,49.951-44.655c18.896-31.05,17.453-47.907,17.453-47.907 s-16.439-4.013-50.016,9.902c-33.579,13.912-51.788,42.513-51.788,42.513s-23.48-6.809-26.77-3.063 c-1.578,1.799-7.467,11.779-13.171,21.679l13.395,7.845c8.492-6.348,17.976-6.116,17.976-6.116s-1.963,7.672,6.518,16.819 c9.174,9.894,15.034,8.335,15.034,8.335s-1.225,9.406-8.8,16.822l5.698,14.443c10.657-4.121,21.423-8.411,23.442-9.695 C334.564,208.983,331.434,184.738,331.434,184.738z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#69459B",
    cx: 350.109,
    cy: 133.927,
    r: 15.867
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#69459B",
    d: "M273.765,258.503c-7.068-9.317-20.349-11.137-29.664-4.069c-0.097,0.073-0.172,0.162-0.267,0.232 c0.243,0.426,0.41,0.919,0.442,1.505c0.135,2.362,0.003,4.689-0.294,6.989c9.099-5.231,20.875-3.031,27.388,5.553 c2.815,3.711,4.199,8.05,4.28,12.375C279.317,274.05,278.88,265.242,273.765,258.503z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69459B",
    d: "M210.765,202.328c10.46,5.231,14.7,17.949,9.471,28.407c-0.054,0.107-0.124,0.199-0.181,0.305 c-0.458-0.162-0.976-0.234-1.559-0.159c-2.346,0.308-4.608,0.863-6.812,1.58c3.46-9.907-0.876-21.077-10.512-25.894 c-4.166-2.082-8.686-2.643-12.955-1.926C194.458,199.742,203.195,198.545,210.765,202.328z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 21.772 344.2012)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fill: "#69459B",
    fontFamily: "'Ubuntu-Bold'",
    fontSize: 69.0953
  }, "EXAM "), /*#__PURE__*/React.createElement("tspan", {
    x: 216.887,
    y: 0,
    fill: "#FFD400",
    fontFamily: "'Ubuntu-Bold'",
    fontSize: 69.0953
  }, "BOOSTER")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/app-logo.13394564d3388c78a4ec336427f43e4f.svg";
export { ForwardRef as ReactComponent };